// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Tooltip_tooltip__1duJP"};